import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../services/security/auth.service';

@Injectable({
    providedIn: 'root'
})

export class LoginGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  async canActivate(): Promise<boolean> {
    if (await this.authService.isAuthenticated()) {        
      this.router.navigate(['/main/portafolio']);
      return false;
    }else{
      return true; 
    }
  }
}
  